import { ENV } from '@hcs/webapps';

import { INTERCOM_APP_ID_PROD, INTERCOM_APP_ID_TEST } from '../constants';

export const useIntercomId = () => {
  return ENV === 'prod' ? INTERCOM_APP_ID_PROD : INTERCOM_APP_ID_TEST;
};
